import { Form } from 'react-bootstrap';
import CrudFormLayout from '../../../Layout/CrudFormLayout';
import FormLabel from '../../../Text/FormLabel';
import ReactInput from '../../../InputList/ReactInput/ReactInput';
import StatusCheck from '../../StatusCheck';

const PopupformsForm = ({ apiHandler, editData }) => {
    const initialValues = {
        name: editData?.name || '',
        phone: editData?.phone || '',
        email: editData?.email || '',
        tourtype: editData?.tourtype || '',
        destination: editData?.destination || '',
        travelcategory: editData?.travelcategory || '',
        selectedMonth: editData?.selectedMonth || '',
        duration: editData?.duration || '',
        adults: editData?.adults || '',
        children: editData?.children || '',
        whatsappComunication: editData?.whatsappComunication || '',
        // whatsappComunication: editData?.whatsappComunication === 'Yes' ? 'Yes' : 'No',
        bookingDate: editData?.bookingDate || '',
        budget: editData?.budget || '',
        userlocation: editData?.userlocation || '',
        status: editData ? editData?.status : 1,
    };

    const formHandler = (formValue) => {
        if (apiHandler) {
            return apiHandler(formValue);
        }

        console.log(formValue);
        return null;
    };

    return (
        <CrudFormLayout initialValues={initialValues} apiHandler={formHandler}>
            <Form.Group className='mt-3'>
                <FormLabel title='Name' />
                <ReactInput name='name' />
            </Form.Group>

            <Form.Group className='mt-3'>
                <FormLabel title='Phone' />
                <ReactInput name='phone' />
            </Form.Group>

            <Form.Group className='mt-3'>
                <FormLabel title='Email' />
                <ReactInput name='email' />
            </Form.Group>

            <Form.Group className='mt-3'>
                <FormLabel title='Tour Type' />
                <ReactInput name='tourtype' />
            </Form.Group>

            <Form.Group className='mt-3'>
                <FormLabel title='Destination' />
                <ReactInput name='destination' />
            </Form.Group>

            <Form.Group className='mt-3'>
                <FormLabel title='Travel Category' />
                <ReactInput name='travelcategory' />
            </Form.Group>

            <Form.Group className='mt-3'>
                <FormLabel title='Selected Month' />
                <ReactInput name='selectedMonth' />
            </Form.Group>

            <Form.Group className='mt-3'>
                <FormLabel title='Duration' />
                <ReactInput name='duration' />
            </Form.Group>

            <Form.Group className='mt-3'>
                <FormLabel title='Adults' />
                <ReactInput name='adults' />
            </Form.Group>

            <Form.Group className='mt-3'>
                <FormLabel title='Children' />
                <ReactInput name='children' />
            </Form.Group>

            <Form.Group className='mt-3'>
                <FormLabel title='WhatsApp Communication' />
                <ReactInput name='whatsappComunication' />
            </Form.Group>

            {/* <Form.Group className='mt-3'>
                <FormLabel title='WhatsApp Communication' />
                <div>
                    <Form.Check
                        type='radio'
                        label='Yes'
                        name='whatsappComunication'
                        value='Yes'
                        checked={initialValues.whatsappComunication === 'Yes'}
                        onChange={(e) => formHandler({ ...initialValues, whatsappComunication: e.target.value })}
                    />
                    <Form.Check
                        type='radio'
                        label='No'
                        name='whatsappComunication'
                        value='No'
                        checked={initialValues.whatsappComunication === 'No'}
                        onChange={(e) => formHandler({ ...initialValues, whatsappComunication: e.target.value })}
                    />
                </div>
            </Form.Group> */}

            <Form.Group className='mt-3'>
                <FormLabel title='Booking Date' />
                <ReactInput name='bookingDate' />
            </Form.Group>

            <Form.Group className='mt-3'>
                <FormLabel title='Budget' />
                <ReactInput name='budget' />
            </Form.Group>

            <Form.Group className='mt-3'>
                <FormLabel title='User Location' />
                <ReactInput name='userlocation' />
            </Form.Group>

            <StatusCheck />
        </CrudFormLayout>
    );
};

export default PopupformsForm;
